import {
  FormStepFailure,
  FormStepSuccess,
  CreateAccountFailureComponent,
  CreateAccountSuccessComponent,
  MultiStepForm,
  FormStep,
  InputField,
  SelectField,
  PasswordField,
  CheckboxField,
  TelephoneField,
  CountryField,
  CurrencyField,
  DateField,
  UsernameField,
  AddressField,
  FieldReference,
  INDIA_STATES,
  SSNField,
  emailRegex,
  CANADA_PROVINCES_TERRITORIES_WITHOUT_ONTARIO,
} from '@whitehatgaming/shared';
import { CreateAccountComponent } from './create-account/create-account.component';

export const register: MultiStepForm = new MultiStepForm({
  rootComponent: CreateAccountComponent,

  success: new FormStepSuccess({
    path: 'success',
    component: CreateAccountSuccessComponent,
  }),

  failure: new FormStepFailure({
    path: 'failed',
    component: CreateAccountFailureComponent,
  }),

  steps: [
    new FormStep({
      key: 'personal-details',
      title: '@personal-details-title',
      supportingText: '@personal-details-supporting-text',
      buttonText: '@personal-details-button-text',
      fields: [
        new InputField({
          key: 'firstname',
          label: '@first-name',
          value: '',
          required: true,
        }),

        new InputField({
          key: 'lastname',
          label: '@last-name',
          value: '',
          required: true,
        }),

        new SelectField({
          key: 'gender',
          label: '@gender',
          value: '',
          placeholder: '@gender-please-select',
          options: [
            { key: 'M', value: '@gender-male' },
            { key: 'F', value: '@gender-female' },
            { key: '', value: '@gender-other' },
          ],
        }),

        new DateField({
          key: 'dob',
          label: '@birth-date',
          preText: '@date-format',
          value: '',
          required: true,
        }),

        new CountryField({
          key: 'country',
          label: '@country',
          required: true,
          skippedDefaultCountries: ['NL', 'SE'],
        }),

        new SelectField({
          key: 'state',
          label: '@state',
          placeholder: '@please-select',
          required: true,
          conditional: '["CA", "IN"].includes(this.form?.controls.country.value || this.country)',
          options: [],
          jurisdictionOptions: {
            CA: CANADA_PROVINCES_TERRITORIES_WITHOUT_ONTARIO,
            IN: INDIA_STATES,
          },
        }),

        new SSNField({
          key: 'ssn',
          label: '@personal-identity-number',
          preText: '@personal-identity-number-help-text',
          value: '',
        }),
      ],
    }),

    new FormStep({
      key: 'address-details',
      buttonText: '@address-details-continue',
      title: '@address-details-title',
      supportingText: '@address-details-supporting-text',
      fields: [
        new InputField({
          key: 'email',
          label: '@email',
          value: '',
          required: true,
          type: 'email',
          pattern: emailRegex,
        }),

        new TelephoneField({
          key: 'phone',
          label: '@phone',
          required: true,
          country: new FieldReference('country'),
        }),

        new AddressField({
          key: 'address',
          label: '@address',
          value: '',
          placeholder: {
            lookupKey: '',
            line1Key: '',
            line2Key: '',
            cityKey: '',
            zipCodeKey: '',
          },
          required: true,
        }),
      ],
    }),

    new FormStep({
      key: 'account-details',
      buttonText: 'Sign up',
      title: '@account-details-title',
      supportingText: '@account-details-supporting-text',
      fields: [
        new UsernameField({
          key: 'username',
          label: '@username',
          value: '',
          preText: '@username-help-text',
          required: true,
        }),

        new PasswordField({
          key: 'password',
          label: '@password',
          preText: '@password-help-text',
          value: '',
          minLength: 8,
          required: true,
          email: new FieldReference('email'),
        }),

        new CurrencyField({
          key: 'currency',
          label: '@currency',
          required: true,
          country: new FieldReference('country'),
        }),

        new CheckboxField({
          key: 'termsPrivacyFunds',
          label: '@terms-and-conditions-privacy-policy-and-funds-policy',
          required: true,
        }),

        new CheckboxField({
          key: 'marketingEmails',
          label: '@marketing-emails',
        }),
      ],
    }),
  ],
});
